import styled from "styled-components";

export const Container = styled.main`
  ul{
    max-width: 320px;
    margin: 0 auto;

    li{
      display: flex;
      align-items: center;
      justify-content: space-between;
      + li{
        margin-top: 24px;
      }

      .ttl{
        color: #666;
      }
      .cont{
        font-size: 16px;
      }
    }

  }
`